import Card from "./Card";
import React from "react";
import PropTypes from "prop-types";

import ChevronDown from "../../svg/ICON_chevronDown_Dark.svg";

/**
 * Card component
 */
export default class CardAccordion extends Card {
  static displayName = "CardAccordion";
  static propTypes = {
    currentPage: PropTypes.object.isRequired,
  };
  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Card";
    this.classModifier = this.className;
    if (props.modifier)
      this.classModifier = `${this.className}--${props.modifier}`;

    this.state = {
      open: null,
    };

    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  /**
 * Show / Hide Accordion
 * @param  {String} cat Clicked Cat
 */
  toggleAccordion(cat) {
    if (this.state.open === cat) {
      this.setState({ open: null });
    } else {
      this.setState({ open: cat });
    }
  }

  /**
 * @override
 */
  render() {
    return (
      <div
        className={`${this.classModifier} accordion
        no-title-border ${this.props.className || ""}`}>
        <div className={`${this.className}__block`}>
          <div
            className={`${this.className}__title`}
            onClick={() => this.toggleAccordion("horaires")}>
            Heures d'ouverture
            {this.props.screen === "mobile"
              ? <img src={ChevronDown} alt="Chevron" />
              : <div className={`${this.className}__border`} />}
          </div>
          <div
            className={`${this.className}__content
            ${this.state.open === "horaires" ? "open" : "close"}`}>
            {this.props.currentPage.timetable().map(openingHours => {
              return (
                <div key={openingHours.ID} className="part">
                  <div className="bold">
                    {openingHours.open()} - {openingHours.close()}
                  </div>
                  <div>
                    {openingHours.Description}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={`${this.className}__block`}>
          <div
            className={`${this.className}__title`}
            onClick={() => this.toggleAccordion("tel")}>
            Téléphone
            {this.props.screen === "mobile"
              ? <img src={ChevronDown} alt="Chevron" />
              : <div className={`${this.className}__border`} />}
          </div>
          <div
            className={`${this.className}__content
            ${this.state.open === "tel" ? "open" : "close"}`}>
            {this.props.currentPage.contacts().map(contact => {
              return (
                <div key={contact.ID} className="part">
                  <div className="bold">
                    {contact.ContactType}
                  </div>
                  <a href={`tel:${contact.Telephone}`}>
                    {contact.Telephone}
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cards/CardAccordion.js